import { motion } from 'framer-motion';
import { SectionCard, Field, RadioSelect, inputClass, textareaClass } from '@/components/SurveyComponents';
import type { SurveyData } from '@/lib/index';

interface Props { data: SurveyData; update: (d: Partial<SurveyData>) => void; }

export function Step3Logistics({ data, update }: Props) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-5">
      <div className="text-center mb-4">
        <h2 className="font-serif text-2xl font-bold text-foreground">Dates & Destination ✈️</h2>
        <p className="text-muted-foreground text-sm mt-1">Let's figure out the when and where.</p>
      </div>
      <SectionCard title="Travel Dates" emoji="📅">
        <Field label="Preferred travel dates or window" required hint="e.g. 'July 4th weekend' or 'anytime in October'">
          <input className={inputClass} placeholder="When are you thinking?" value={data.preferredDates} onChange={e => update({ preferredDates: e.target.value })} />
        </Field>
        <Field label="How flexible are your dates?">
          <RadioSelect cols={2} options={['Exact dates locked','Flexible by a week','Flexible by a month','Completely open']} value={data.flexibility} onChange={v => update({ flexibility: v })} />
        </Field>
        <Field label="How many nights?" required>
          <RadioSelect cols={3} options={['2–3 nights','4–5 nights','6–7 nights','8–10 nights','10+ nights','Not sure yet']} value={data.duration} onChange={v => update({ duration: v })} />
        </Field>
      </SectionCard>
      <SectionCard title="Destination" emoji="🌍">
        <Field label="Do you have a destination in mind?" required>
          <RadioSelect cols={1} options={['Yes, I know exactly where I want to go','I have a few ideas — open to suggestions','No idea yet — I trust your judgment completely']} value={data.hasDestination} onChange={v => update({ hasDestination: v })} />
        </Field>
        {data.hasDestination && data.hasDestination !== 'No idea yet — I trust your judgment completely' && (
          <Field label="What destinations are you considering?" hint="List as many as you want">
            <textarea className={textareaClass} placeholder="e.g. Tulum, Cabo, Puerto Vallarta, Scottsdale..." value={data.destinationIdeas} onChange={e => update({ destinationIdeas: e.target.value })} />
          </Field>
        )}
        <Field label="Are you open to international travel?" required>
          <RadioSelect cols={2} options={['Yes, passport ready!','Yes, but need easy visa process','US domestic only','Not sure']} value={data.internationalOk} onChange={v => update({ internationalOk: v })} />
        </Field>
        <Field label="Any destinations to absolutely avoid?" hint="Bad experiences, safety concerns, off limits for any reason">
          <input className={inputClass} placeholder="e.g. 'Not ready for Asia yet' or 'Avoiding spring break crowds'" value={data.avoidDestinations} onChange={e => update({ avoidDestinations: e.target.value })} />
        </Field>
      </SectionCard>
    </motion.div>
  );
}
